var map = {
	"./AliPay.svg": "f2ae",
	"./BELFIUS_PAY_BUTTON.svg": "60c0",
	"./Card.svg": "19df",
	"./IDEAL.svg": "6723",
	"./ING_HOME_PAY.svg": "8c48",
	"./KBC.svg": "80b6",
	"./MAESTRO.svg": "d145",
	"./MISTERCASH.svg": "d00a",
	"./PAYPAL_EXPRESS_CHECKOUT.svg": "e427",
	"./POINT_OF_SALE.svg": "1f47",
	"./WeChat.svg": "6aa4",
	"./arrow-down.svg": "896a",
	"./bike.svg": "8813",
	"./cards/amex.svg": "e006",
	"./cards/bancontact.svg": "85c4",
	"./cards/maestro.svg": "b33f",
	"./cards/mastercard.svg": "c241",
	"./cards/unknown.svg": "43ff",
	"./cards/visa.svg": "844b",
	"./issuers/ABNAMRO.svg": "9cef",
	"./issuers/ASN.svg": "b641",
	"./issuers/BUNQ.svg": "fcb6",
	"./issuers/Binck.svg": "19af",
	"./issuers/HAND.svg": "06d1",
	"./issuers/ING.svg": "5bbb",
	"./issuers/KNAB.svg": "9103",
	"./issuers/MOYO.svg": "2eff",
	"./issuers/RABO.svg": "f468",
	"./issuers/REGIOBANK.svg": "7dc4",
	"./issuers/REVOLUT.svg": "17c3",
	"./issuers/SNS.svg": "2a35",
	"./issuers/Sofort.svg": "dfca",
	"./issuers/TRIODOS.svg": "2506",
	"./issuers/VANLANSCHOT.svg": "feda",
	"./issuers/YOURSAFE.svg": "8082"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";